import { SET_ALERT, REMOVE_ALERT } from '../types';

/* eslint import/no-anonymous-default-export: */
export default (state, action) => {
  switch (action.type) {
    case SET_ALERT:
      return action.payload;
    case REMOVE_ALERT:
      return null;
    default:
      return state;
  }
};
